import React from 'react';
import AddMinSidebar from '../AddMinSidebar/AddMinSidebar';
import RegisterList from '../RegisterList/RegisterList';

const Admin = () => {
    return (
        <div>
            <AddMinSidebar></AddMinSidebar>
            <RegisterList></RegisterList>
        </div>
    );
};

export default Admin;